<div class='top'>
  <h1>{{pem.name}}</h1>
</div>

<div class='bottom'>
  <div contenteditable='false' id='pem-description' [style.height]='textareaHeight("pem-description", 200)' [innerHTML]="pem.description"></div>
</div>